module.exports = __webpack_public_path__ + "img/mt.23c648a.svg";